import * as React from "react";
import { FC } from "react";

import { Anchor, Box, Flex, Text } from "@costar/theme-ui";
import { IconArrowThickRight } from "@costar/theme-ui-icons/csg/IconArrowThickRight";

type SelectorFooterProps = {
    centralPrefUrl: string;
    customizeLinkText: string;
};

const SelectorFooter: FC<SelectorFooterProps> = ({ centralPrefUrl, customizeLinkText }) => {
    return (
        <Box
            style={{
                borderTop: "1px solid #e0e0e0",
                paddingTop: "24px",
                backgroundColor: "#FCFDFD",
            }}
        >
            <Flex justifyContent="flex-end">
                <Anchor
                    href={centralPrefUrl}
                    style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}
                >
                    <Text fontSize="sm">{customizeLinkText}</Text>
                    <IconArrowThickRight />
                </Anchor>
            </Flex>
        </Box>
    );
};

export default React.memo(SelectorFooter);
